  
const ButtonElement = ({
  variant = "primary",        // bootstrap variant
  size = "sm",                 // default size
  type = "submit",             // default type
  loading = false,
  disabled = false,
  text = "Submit",
  loadingText = "Submitting...",
  className = "",
  style = {},
  onClick,
}) => {
  
  
  return (
    <button
      type={type}
      className={`btn btn-${variant} btn-${size} ${className}`}
      style={style}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" />
          {loadingText}
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default ButtonElement;
